import React from 'react';

const Footer = () => {
  return (
    <div id="footer" className="text-center">
      <div className="container">
        <div className="socials-media text-center">
          <ul className="list-unstyled">
            <li><a href="https://github.com/Jamesiukalu" target='_blank' rel="noreferrer"><i className="bi bi-github"></i></a></li>
            <li><a href="https://x.com/jamesiukalu" target='_blank' rel="noreferrer"><i className="bi bi-twitter-x"></i></a></li>
            <li><a href="https://www.behance.net/jamesiukalu" target='_blank' rel="noreferrer"><i className="bi bi-behance"></i></a></li>
            <li><a href="https://www.linkedin.com/in/jamesiukalu/" target='_blank' rel="noreferrer"><i className="bi bi-linkedin"></i></a></li>
          </ul>
        </div>
        <p>&copy; 2026 James Kalu. All rights reserved.</p>
        {/* <div className="credits">
          Designed by <a href="/">Jamesiukalu</a>
        </div> */}
      </div>
    </div>
  );
};

export default Footer;
